module.exports = __webpack_public_path__ + "assets/img/icon22.626057c4.png";